import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_RAV2_CIC_REQUEST = 'FETCH_RAV2_CIC_REQUEST';
export const FETCH_RAV2_CIC_SUCCESS = 'FETCH_RAV2_CIC_SUCCESS';
export const FETCH_RAV2_CIC_FAILURE = 'FETCH_RAV2_CIC_FAILURE';

const buildRAv2CicUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/ra-cic`);

export function fetchRAv2CicIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildRAv2CicUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchRAv2Cic(sessionId));
  };
}

export function fetchRAv2Cic(sessionId) {
  return (dispatch) => {
    const url = buildRAv2CicUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchRAv2CicRequest()).payload
      .then((response) => dispatch(fetchRAv2CicSuccess(response)))
      .catch((error) => {
        if (error.response && error.response.code === 404) {
          return dispatch(fetchRAv2CicSuccess());
        }

        return dispatch(fetchRAv2CicFailure(error));
      });

    function fetchRAv2CicRequest() {
      return ApiCall.createAction({
        type: FETCH_RAV2_CIC_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchRAv2CicSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_RAV2_CIC_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
      });
    }

    function fetchRAv2CicFailure(error) {
      return ApiCall.createAction({
        type: FETCH_RAV2_CIC_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/RAv2Cic/actions.js